import {List, Map, Record} from "immutable";
import * as createjs from "@createjs/core";

const VoyageHistoryRecord = Record({
  vessel_id: 0,
  started_at: null,
  ended_at: null,
  total_seconds: null,
  progress_max: 100,
  progress_min: 0
});

export default {
  setReady: (state, flag) => {
    state.isReady = flag;
  },
  addLoadedLayer: (state, layerName) => {
    state.loaded_layers = state.loaded_layers.push(layerName);
  },
  clear: state => {
    state.isReady = false;
    state.loaded_layers = List();
    state.voyage_history = null;
    state.my_vessel_positions = List();
    state.my_vessel_wake = List();
    state.vessel_positions = List();
    state.before_vessel_positions = Map();
    state.movement_vessels = Map();
    state.backup_index = {wake: 0, my_pos: 0, other_pos: 0};
    state.vessels = Map();
    state.tick = false;
    state.fps = 1;
    state.start_time = null;
    state.end_time = null;
    state.current_time = 0;
    state.is_pause = true;
    createjs.Ticker.framerate = 1;
    createjs.Ticker.paused = true;
    createjs.Ticker.removeEventListener("tick");
  },
  updateTick: (state, payload) => {
    state.tick = payload ? !payload : payload;
  },
  updateFPS: (state, fps) => {
    state.fps = fps;
  },
  setCurrentTime: (state, time) => {
    state.current_time = time;
  },
  setGcTime: (state, time) => {
    state.gc_time = time;
  },
  setStartTime: (state, time) => {
    state.start_time = time;
  },
  setEndTime: (state, time) => {
    state.end_time = time;
  },
  setVoyageHistorySummary: (state, payload) => {
    state.voyageHistorySummary = {
      users: List(payload.users),
      vessels: List(payload.vessels)
    };
  },
  setEnterpriseVoyageHistories: (state, payload) => {
    state.enterpriseVoyageHistories = payload.summaries;
  },
  setProjectEnterpriseId: (state, payload) => {
    state.project.enterpriseId = payload;
  },
  setVoyageHistoryUserLogs: (state, payload) => {
    state.voyageHistoryUserLogs = List(payload);
  },
  setVoyageHistoryVesselLogs: (state, payload) => {
    state.voyageHistoryVesselLogs = List(payload);
  },
  setPlayHistoryId: (state, payload) => {
    state.playHistoryId = payload;
  },
  setDeleteHistoryId: (state, payload) => {
    state.deleteHistoryId = payload;
  },
  setHistoryPreviousTime: (state, payload) => {
    state.history.previousTime = payload;
  },
  setHistoryPlayVessels: (state, payload) => {
    state.history.playVessels = payload;
  },
  setHistoryWakes: (state, payload) => {
    state.history.wakes = payload;
  },
  setPlaySpeed: (state, payload) => {
    state.history.playSpeed = payload;
  },
  setPause: (state, payload) => {
    state.is_pause = payload;
  },
  setReverse: (state, payload) => {
    state.history.isReverse = payload;
  },
  clearHistory: state => {
    state.histories = {};
    state.history = {
      currentTime: null, // APIから取得した最初の時刻を設定,
      previousTime: null, // 前回再生時間
      isReverse: false,
      playSpeed: 1,
      playVessels: [],
      wakes: [],
      isPause: false
    };
    state.playHistoryId = "";
  },
  setVoyageHistory: (state, voyage_history) => {
    state.voyage_history = new VoyageHistoryRecord(voyage_history);
  },
  setMyVesselWake: (state, payload) => {
    state.my_vessel_wake = List(payload);
  },
  setMyVesselWakeAll: (state, payload) => {
    state.my_vessel_wake_all = payload;
  },
  addMyVesselWake: (state, payload) => {
    state.my_vessel_wake = state.my_vessel_wake.push(payload);
  },
  clearMyVesselWake: state => {
    state.my_vessel_wake = List();
  },
  setMapInfo: (state, mapInfo) => {
    state.map_info.south_west = {
      lat: mapInfo.south_west.lat,
      lon: mapInfo.south_west.lng
    };
    state.map_info.north_east = {
      lat: mapInfo.north_east.lat,
      lon: mapInfo.north_east.lng
    };
  },
  setMapCenter: (state, center) => {
    state.map_info.center = center;
  },
  setBackupIndexWake: (state, index) => {
    state.backup_index.wake = index;
  },
  setBackupIndexMyPos: (state, index) => {
    state.backup_index.my_pos = index;
  },
  setBackupIndexOtherPos: (state, index) => {
    state.backup_index.other_pos = index;
  },
  setMyVesselPositions: (state, payload) => {
    state.my_vessel_positions = List(payload);
  },
  setMyVesselPositionAll: (state, payload) => {
    state.my_vessel_position_all = List(payload);
  },
  setMyVesselPositionIndexes: (state, payload) => {
    state.my_vessel_position_indexes = payload;
  },
  setVesselPosition: (state, record) => {
    state.vessel_positions = state.vessel_positions.push(record);
  },
  mergeVesselPositions: (state, records) => {
    state.vessel_positions = Object.freeze(state.vessel_positions.concat(records));
  },
  clearVesselPosition: (state) => {
    state.vessel_positions = List();
    state.before_vessel_positions = Map();
  },
  setBeforeVesselPosition: (state, record) => {
    state.before_vessel_positions = state.before_vessel_positions.set(record.vessel_id, record);
  },
  mergeBeforeVesselPositions: (state, records) => {
    state.before_vessel_positions = Object.freeze(state.before_vessel_positions.merge(records));
  },
  setMovementVessels: (state, map) => {
    state.movement_vessels = state.movement_vessels.merge(map);
  },
  setMovementVessels2: (state, map) => {
    state.movement_vessels = map;
  },
  setVessels: (state, map) => {
    state.vessels = Map(map);
  },
  setStep: (state, step) => {
    state.step = step;
  },
  setBaseIndex: (state, index) => {
    state.base_index = index;
  },
  setMaxIndex: (state, index) => {
    state.max_index = index;
  },
  setPageable: (state, pageable) => {
    state.pageable = pageable;
  },
  setChangeSliderStatus: (state, bool) => {
    state.change_slider = bool;
  },
  setSearchVessels: (state, vessels) => {
    state.search_vessels = vessels;
  },
  setSearchUsers: (state, users) => {
    state.search_users = users;
  },
  RESET_VOYAGE_HISTORY_STATE (state) {
    state.search_users = [];
  },
  RESET_PAGEABLE_STATE(state) {
    state.pageable = null
  },
};
